module.exports = __webpack_public_path__ + "static/media/logo_geseco.9920af91.png";